import { render, staticRenderFns } from "./ReparticionPage.vue?vue&type=template&id=1b5b3784"
import script from "./ReparticionPage.js?vue&type=script&lang=js&external"
export * from "./ReparticionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports